export default __webpack_public_path__ + "static/media/ikon-pencarian.7f1a7ca7.svg";